import PropTypes from "prop-types";

import { useEffect, useMemo, useState } from "react";

import Card from "react-bootstrap/Card";

import {
  WORKSPACE_TYPE_PRIVATE,
  WORKSPACE_TYPE_PUBLIC,
  TILE_TYPE_GROUP_OF_TILES,
} from "../../constants/stringConstants";

import DesignedLabel from "../DesignedLabel";

import { useTranslation } from "react-i18next";

import iconsEdit from "../../assets/svg/icons-edit.svg";

import iconsDelete from "../../assets/svg/icons-delete.svg";
import { formatDate } from "../formatDate";
import CustomModal from "../CustomModal";

import { deleteTile, updateTile } from "../../actions/tileActions";

import {
  addNewsItem,
  addNewsItemAction,
  filterFailureMessageRaised,
  filterSuccessMessageRaised,
  getFilterTypes,
} from "../../actions/filterActions";

import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";

import FieldsInForm from "../../utils/FieldsInForm";

import iconsAddToList from "../../assets/svg/icons-addToList-second.svg";
import axios from "axios";
import { ADD_NEWS } from "../../constants/urls";
import AlertMessage from "../AlertMessage";
import DOMPurify from "dompurify";

const CardAiAnalysisCustom = ({
  card,
  userEmail,
  singleTopic,
  userToken,
  deleteTile,
  updateTile,
  id,
  fromDocumentContainer,
  fromCardAssessmentContainer,
  singleTile,
  getFilterTypes,
  filtersTypes,
  tileTypes,
}) => {
  const { aiModel, frequecy, publicationTypes } = useMemo(() => {
    return {
      publicationTypes:
        filtersTypes.find((obj) =>
          Object.keys(obj)?.at(0).includes("publication_type")
        ) ?? {},

      aiModel:
        filtersTypes.find((obj) =>
          Object.keys(obj)?.at(0).includes("aimodel")
        ) ?? {},
      frequecy:
        filtersTypes.find((obj) =>
          Object.keys(obj)?.at(0).includes("frequency")
        ) ?? {},
    };
  }, [filtersTypes]);

  const sanitizer = DOMPurify.sanitize;

  const { t } = useTranslation();
  const [textIsClicked, setTextIsClicked] = useState(false);
  const [isDeletedDialogOpened, setIsDeletedDialogOpened] = useState(false);
  const [isEditDialogOpened, setIsEditDialogOpened] = useState(false);

  const values = useMemo(() => {
    let result;

    try {
      result = JSON.parse(card.TILE_VALUE);
    } catch {
      result = {
        AI_PROMPT: "",
        AI_MODEL: "",
        FREQUENCY: "",
        PUBLICATION_TYPES: "",
        PUBLISH: "",
        AI_RESULTS: "",
      };
    }

    return result;
  }, [card.TILE_VALUE]);

  let checkPublish = { publish_1: "Yes", publish_2: "No" };
  const [data, setData] = useState({
    TILE_NAME: card.TILE_NAME,
    AI_PROMPT: values.AI_PROMPT ?? "",
    AI_MODEL: values.AI_MODEL || Object.values(aiModel)?.at(0) || "",
    FREQUENCY: values.FREQUENCY || Object.values(frequecy)?.at(0) || "",
    PUBLICATION_TYPES:
      values.PUBLICATION_TYPES.split(";").reduce(
        (newArr, pubTypeStr, idx, arr) => {
          if (idx === arr.length - 1) {
            return newArr;
          }
          let string = pubTypeStr;
          let result = string.replace(/type /g, "").split(",")[0];

          return [...newArr, { value: result, description: result }];
        },
        []
      ) ?? [],
    PUBLISH:
      checkPublish.v !== undefined
        ? checkPublish.v
        : Object.values(checkPublish)?.at(0),
  });

  const [submitOccurred, setSubmitOccurred] = useState(false);
  const [isPushedDialogOpened, setIsPushedDialogOpened] = useState(false);
  const [url, setUrl] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [failureMessage, setFailureMessage] = useState("");
  const dispatch = useDispatch();

  const argsForEditTextTileDialog = {
    findFormErrors: () => {
      const newErrors = {};

      if (!data.TILE_NAME || data.TILE_NAME === "")
        newErrors.TILE_NAME = t("tileNameIsMandatory");
      else if (data.TILE_NAME.length > 255)
        newErrors.TILE_NAME = t("tileNameCantBeLongerThan255Charachteres");

      return newErrors;
    },
    fieldsForEditTextTile: [
      {
        name: "TILE_NAME",
        type: "text",
        className: "register-login-text-field",
        required: true,
        label: t("nameTheTile"),
        placeholder: t("egIdentifiedRisks"),
        onChangeText: (value) =>
          setData((prev) => ({ ...prev, TILE_NAME: value })),
        value: data.TILE_NAME,
      },
      {
        name: "AI_PROMPT",
        type: "textarea",
        className: "textarea-for-search-criteria",
        required: true,
        displayProperty: "description",
        valueProperty: "value",
        label: t("AI Prompt"),
        onChangeText: (value) =>
          setData((prev) => ({ ...prev, AI_PROMPT: value })),
        value: data.AI_PROMPT,
        placeholder: t("Add your AI Prompt here"),
      },
      {
        name: "AI_MODEL",
        type: "select",
        className: "register-login-text-field ",
        options: Object.entries(aiModel).map(([, v]) => ({
          value: v,
          description: v,
        })),
        required: true,
        displayProperty: "description",
        valueProperty: "value",
        label: t("Ai Model"),
        onChange: (value) => setData((prev) => ({ ...prev, AI_MODEL: value })),
        value: data.AI_MODEL,
      },
      {
        name: "FREQUENCY",
        type: "select",
        className: "register-login-text-field",
        options: Object.entries(frequecy).map(([k, v]) => ({
          value: k,
          description: v,
        })),
        required: true,
        label: t("Frequency"),
        onChange: (value) => setData((prev) => ({ ...prev, FREQUENCY: value })),
        value: data.FREQUENCY,
        displayProperty: "description",
      },
      {
        name: "PUBLICATION TYPES",
        type: "multi-select",
        className: "register-login-text-field",
        options: Object.entries(publicationTypes).map(([k, v]) => ({
          value: k,
          description: v,
        })),
        required: true,
        label: t("Relevant Publication Types"),
        onMultiSelectOptionChanged: (field, value) => {
          setData((prev) => {
            const obj = prev.PUBLICATION_TYPES.find((o) => o.value === field);

            if (!obj) {
              return {
                ...prev,
                PUBLICATION_TYPES: [
                  ...prev.PUBLICATION_TYPES,
                  { value: field, description: value },
                ],
              };
            }

            return prev;
          });
        },
        onMultiSelectOptionRemoved: (field) =>
          setData((prev) => ({
            ...prev,
            PUBLICATION_TYPES: prev.PUBLICATION_TYPES.filter(
              (o) => o.value !== field
            ),
          })),
        selectedOptions: data.PUBLICATION_TYPES,
        displayProperty: "description",
        valueProperty: "value",
      },
      {
        name: "Publish AI Analysis to the newsstream",
        type: "select",
        className: "register-login-text-field ",
        options: Object.entries(checkPublish).map(([, v]) => ({
          value: v,
          description: v,
        })),
        required: true,
        displayProperty: "description",
        valueProperty: "value",
        label: t("Publish AI Analysis to the newsstream"),
        onChange: (value) => setData((prev) => ({ ...prev, PUBLISH: value })),
        value: data.PUBLISH,
      },
    ],
    onSubmit: () => {
      setIsEditDialogOpened(false);
      updateTile({
        usertoken: userToken,
        tile_id: card.TILE_ID,
        tile_name: data.TILE_NAME,
        tile_value: {
          AI_PROMPT: data.AI_PROMPT,
          AI_MODEL: data.AI_MODEL,
          FREQUENCY: data.FREQUENCY,
          PUBLICATION_TYPES: data?.PUBLICATION_TYPES.reduce(
            (acc, i) => (acc += `type ${i?.description};`),
            ""
          ),
          PUBLISH: data.PUBLISH,
        },
        tile_audience: card.TILE_AUDIENCE,
        tile_type: card.TILE_TYPE,
        topic_id: fromDocumentContainer
          ? id
          : fromCardAssessmentContainer
          ? singleTile.TILE_ID
          : singleTopic.TOPIC_ID,
        tile_types: fromCardAssessmentContainer
          ? TILE_TYPE_GROUP_OF_TILES
          : undefined,
      });
      // updateTile(
      //   userToken,
      //   card.TILE_ID,
      //   data.TILE_NAME,
      //   {
      //     AI_PROMPT: data.AI_PROMPT,
      //     AI_MODEL: data.AI_MODEL,
      //     FREQUENCY: data.FREQUENCY,
      //     PUBLICATION_TYPES: data?.PUBLICATION_TYPES.reduce(
      //       (acc, i) => (acc += `type ${i?.description};`),
      //       ""
      //     ),
      //     PUBLISH: data.PUBLISH,
      //   },
      //   card.TILE_AUDIENCE,
      //   card.TILE_TYPE,
      //   fromDocumentContainer
      //     ? id
      //     : fromCardAssessmentContainer
      //     ? singleTile.TILE_ID
      //     : singleTopic.TOPIC_ID,
      //   fromCardAssessmentContainer ? TILE_TYPE_GROUP_OF_TILES : undefined
      // );
    },
  };
  useEffect(() => {
    setUrl(window.location.href);
    getFilterTypes(userToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [html, setHtml] = useState("");

  useEffect(() => {
    setHtml(data.TILE_NAME);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let title = singleTopic.TOPIC_NAME;

  const matchingObjects = tileTypes.filter(
    (obj) => obj.TILE_TYPE_NAME === card.TILE_TYPE
  );

  return (
    <>
      <Card className="card-tile card-tile-text">
        <Card.Header>
          <div className="cardHeaderWrapper">
            {matchingObjects &&
              matchingObjects.map((item) => (
                <img
                  key={item.TILE_NAME}
                  width={30}
                  height={30}
                  src={item.TILE_TYPE_ICON_PATH}
                  alt={item.TILE_NAME}
                />
              ))}
            <span className="tile-name"> {card.TILE_NAME}</span>
          </div>
          <DesignedLabel
            label={WORKSPACE_TYPE_PRIVATE.toUpperCase()}
            classNameLabel={
              card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE
                ? "private-label"
                : "display-none"
            }
          />
          <DesignedLabel
            label={t("partnerContent").toUpperCase()}
            classNameLabel={
              (card.PARTNER === "TRUE" || card.PARTNER === true) &&
              card.TILE_AUDIENCE === WORKSPACE_TYPE_PUBLIC
                ? "partner-content-label"
                : "display-none"
            }
          />
        </Card.Header>
        <Card.Body className="tile-body">
          <Card.Title className="tile-created-by">
            {t("createdBy") + ": "}
            <img
              width={24}
              height={24}
              src={card.CREATOR_LOGO}
              className={
                card.CREATOR_LOGO ? "created-by-logo-tile" : "display-none"
              }
            />
            {card.CREATED_BY}
          </Card.Title>
          <Card.Text
            className="tile-text cursor-pointer"
            onClick={() => setTextIsClicked(!textIsClicked)}
            dangerouslySetInnerHTML={{
              __html: sanitizer(
                card.AI_RESULTS?.length &&
                  card.AI_RESULTS.slice(0, 252) +
                    "<span class='three-point'>...</span>"
              ),
            }}
          />
          {/* {values.AI_PROMPT.length &&
            values.AI_PROMPT != htmlToLength(values.AI_PROMPT, 252)
              ? Parser(
                  htmlToLength(values.AI_PROMPT, 252) +
                    "<span class='three-point'>...</span>"
                )
              : Parser(values.AI_PROMPT)}
          </Card.Text> */}
        </Card.Body>
        <Card.Footer className="tile-footer">
          <Card.Text className="tile-last-updated">
            {t("lastUpdated") +
              ": " +
              formatDate(new Date(card.TILE_LAST_UPDATE), "dd.mm.yyyy")}
          </Card.Text>
          <Card.Text
            className={
              card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE ||
              card.CREATED_BY === userEmail
                ? "tile-edit-or-updated"
                : "display-none"
            }
          >
            {card.TILE_AUDIENCE !== WORKSPACE_TYPE_PRIVATE && (
              <span
                onClick={() => setIsPushedDialogOpened(true)}
                className="card-topic-group-footer-option"
              >
                <img
                  width={32}
                  height={32}
                  src={iconsAddToList}
                  className="card-topic-group-footer-img-add"
                />
                {t("push")}
              </span>
            )}
            <span
              onClick={() => setIsEditDialogOpened(true)}
              className="card-topic-group-footer-option"
            >
              <img
                width={24}
                height={24}
                src={iconsEdit}
                className="card-topic-group-footer-img"
              />
              {t("edit")}
            </span>
            <span
              className="card-topic-group-footer-option"
              onClick={() => setIsDeletedDialogOpened(true)}
            >
              <img
                width={24}
                height={24}
                src={iconsDelete}
                className="card-topic-group-footer-img"
              />
              {t("delete")}
            </span>
          </Card.Text>
        </Card.Footer>
      </Card>
      <CustomModal
        classNameOfModal="reghub-modal"
        titleOfModal={t("pushNews")}
        setIsShown={setIsPushedDialogOpened}
        isShown={isPushedDialogOpened}
        negativeAction={() => setIsPushedDialogOpened(false)}
        content={
          <>
            <span className="modal-dialog-row-of-text fs-14">
              {t("youAreAboutToPushATile")}
            </span>
            <br />
            <span className="modal-dialog-row-of-text fs-14">
              {t("areYouSureYouWantToPushATile")}
            </span>
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("pushNews")}
        positiveAction={() => {
          let axiosConfig = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };

          let bodyFormData = new FormData();
          bodyFormData.append("usertoken", userToken);
          bodyFormData.append("news_title", card.TILE_NAME);
          bodyFormData.append("description", html);
          bodyFormData.append("content", html);
          bodyFormData.append("country", "Global");
          bodyFormData.append("url", url);
          bodyFormData.append("publication_type", "Assessments");
          bodyFormData.append("publisher", card.CREATED_BY);
          bodyFormData.append("publisher_type", "Information Provider");
          bodyFormData.append("publication_date", card.TILE_LAST_UPDATE);
          bodyFormData.append("topics", title);
          bodyFormData.append("curated", "yes");

          const asString = new URLSearchParams(bodyFormData).toString();

          axios
            .post(ADD_NEWS, asString, axiosConfig)
            .then((response) => {
              dispatch(addNewsItemAction(response.data.RegHub_response));
              setSuccessMessage("The news has been added successfully.");
            })
            .catch((err) => {
              setFailureMessage(err?.response?.data);
            });

          setIsPushedDialogOpened(false);
        }}
        isBackdrop="static"
        isCentered={true}
      />
      <CustomModal
        classNameOfModal="reghub-modal"
        titleOfModal={t("deleteATile")}
        setIsShown={setIsDeletedDialogOpened}
        isShown={isDeletedDialogOpened}
        negativeAction={() => setIsDeletedDialogOpened(false)}
        content={
          <>
            <span className="modal-dialog-row-of-text fs-14">
              {t("youAreAboutToDeleteATile")}
            </span>
            <br />
            <span className="modal-dialog-row-of-text fs-14">
              {t("areYouSureYouWantToDeleteATile")}
            </span>
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("deleteATile")}
        positiveAction={() =>
          deleteTile(
            userToken,
            card.TILE_ID,
            fromDocumentContainer
              ? id
              : fromCardAssessmentContainer
              ? singleTile.TILE_ID
              : singleTopic.TOPIC_ID,
            fromCardAssessmentContainer ? TILE_TYPE_GROUP_OF_TILES : undefined
          )
        }
        isBackdrop="static"
        isCentered={true}
      />
      <CustomModal
        classNameOfModal="reghub-modal edit-tile-modal edit-text-tile"
        titleOfModal={t("editTile")}
        setIsShown={setIsEditDialogOpened}
        isShown={isEditDialogOpened}
        negativeAction={() => {
          setIsEditDialogOpened(false);
        }}
        content={
          <>
            <div className="tile-information">
              <span className="tile-name fs-28">{card.TILE_NAME}</span>
              <span className="tile-audience-type fs-16">
                {card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE
                  ? t("privateTile") + " | " + card.TILE_TYPE
                  : t("publicTile") + " | " + card.TILE_TYPE}
              </span>
            </div>
            <FieldsInForm
              fields={argsForEditTextTileDialog.fieldsForEditTextTile}
              findFormErrors={argsForEditTextTileDialog.findFormErrors}
              submitOccurred={submitOccurred}
              setSubmitOccurred={setSubmitOccurred}
              onSubmit={argsForEditTextTileDialog.onSubmit}
            />
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("saveEdits")}
        positiveAction={() => setSubmitOccurred(true)}
        isBackdrop="static"
        isCentered={true}
      />
      <CustomModal
        classNameOfModal="reghub-modal edit-tile-modal full-view-tile-modal"
        titleOfModal={
          <div className="tile-information">
            <span className="tile-name fs-28">{card.TILE_NAME}</span>
            <span className="tile-audience-type fs-16">
              {card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE
                ? t("privateTile") + " | " + card.TILE_TYPE
                : t("publicTile") + " | " + card.TILE_TYPE}
            </span>
          </div>
        }
        setIsShown={setTextIsClicked}
        isShown={textIsClicked}
        negativeAction={() => setTextIsClicked(false)}
        content={
          <>
            <div
              className="tile-full-view-content"
              dangerouslySetInnerHTML={{
                __html: sanitizer(card.AI_RESULTS),
              }}
            />
          </>
        }
        isBackdrop="static"
        isCentered={true}
      />
      {successMessage ? (
        <AlertMessage
          variant="success"
          onClose={() => {
            filterSuccessMessageRaised(successMessage);
            setSuccessMessage("");
          }}
          successHeading={t("success")}
          mainMessage={successMessage}
        />
      ) : (
        <div className="display-none" />
      )}
      {failureMessage ? (
        <AlertMessage
          variant="danger"
          onClose={() => {
            filterFailureMessageRaised(failureMessage);
            setFailureMessage("");
          }}
          successHeading={t("failure")}
          mainMessage={failureMessage}
        />
      ) : (
        <div className="display-none" />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    singleTile: state.tileReducer.singleTile,
    singleTopic: state.topicReducer.singleTopic,
    filtersTypes: state.filterReducer.filtersTypes,
    tileTypes: state.tileReducer.tileTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteTile: bindActionCreators(deleteTile, dispatch),
    updateTile: bindActionCreators(updateTile, dispatch),
    addNewsItem: bindActionCreators(addNewsItem, dispatch),
    getFilterTypes: bindActionCreators(getFilterTypes, dispatch),
  };
};

CardAiAnalysisCustom.propTypes = {
  card: PropTypes.shape({
    CREATED_BY: PropTypes.string,
    TILE_AUDIENCE: PropTypes.string,
    TILE_ICON_PATH: PropTypes.string,
    TILE_ID: PropTypes.number,
    TILE_LAST_UPDATE: PropTypes.string,
    TILE_NAME: PropTypes.string,
    TILE_STATUS: PropTypes.string,
    TILE_TYPE: PropTypes.string,
    TILE_VALUE: PropTypes.string,
    CREATOR_LOGO: PropTypes.string,
    AI_RESULTS: PropTypes.string,
    PARTNER: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }).isRequired,
  userEmail: PropTypes.string.isRequired,
  singleTopic: PropTypes.shape({
    TOPIC_ID: PropTypes.number,
    TOPIC_NAME: PropTypes.string,
  }),
  userToken: PropTypes.string.isRequired,
  deleteTile: PropTypes.func.isRequired,
  updateTile: PropTypes.func.isRequired,
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fromDocumentContainer: PropTypes.bool,
  fromCardAssessmentContainer: PropTypes.bool,
  singleTile: PropTypes.shape({
    TILE_ID: PropTypes.number,
  }).isRequired,
  // addNewsItem: PropTypes.func.isRequired,
  getFilterTypes: PropTypes.func.isRequired,
  filtersTypes: PropTypes.array.isRequired,
  tileTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

CardAiAnalysisCustom.defaultProps = {
  card: {
    CREATED_BY: "",
    TILE_AUDIENCE: "",
    TILE_ICON_PATH: "",
    TILE_ID: 0,
    TILE_LAST_UPDATE: "",
    TILE_NAME: "",
    TILE_STATUS: "",
    TILE_TYPE: "",
    TILE_VALUE: "",
    CREATOR_LOGO: "",
  },
  userEmail: "",
  singleTopic: {},
  userToken: "",
  deleteTile: () => {},
  updateTile: () => {},
  currentWorkspace: {},
  id: "",
  fromDocumentContainer: false,
  fromCardAssessmentContainer: false,
  singleTile: {},
  pushTile: () => {},
  addNewsItem: () => {},
  getFilterTypes: () => {},
  filtersTypes: [],
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardAiAnalysisCustom);
